var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.403%",
    y1: "28.559%",
    x2: "82.176%",
    y2: "73.128%",
    id: "u9gwp9vqqa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753CBE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB9EE",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.17 24.988 9.156-9.075-9.156-9.07a3.931 3.931 0 0 1 0-5.596 4.02 4.02 0 0 1 5.647 0l9.154 9.073 9.156-9.073a4.02 4.02 0 0 1 5.647 0 3.931 3.931 0 0 1 0 5.595l-9.156 9.071 9.156 9.073a3.933 3.933 0 0 1 1.088 3.848 3.975 3.975 0 0 1-2.852 2.825 4.017 4.017 0 0 1-3.883-1.08l-9.156-9.07-9.157 9.073a4.018 4.018 0 0 1-5.644 0 3.93 3.93 0 0 1 0-5.594zm76.349-9.075 9.156-9.073a3.933 3.933 0 0 0 1.119-3.861 3.975 3.975 0 0 0-2.867-2.84 4.017 4.017 0 0 0-3.897 1.108l-9.158 9.073-9.154-9.073a4.02 4.02 0 0 0-5.648 0 3.931 3.931 0 0 0 0 5.595l9.157 9.071-9.157 9.073a3.933 3.933 0 0 0-1.088 3.848 3.975 3.975 0 0 0 2.853 2.825 4.017 4.017 0 0 0 3.883-1.08l9.154-9.07 9.156 9.073a4.02 4.02 0 0 0 5.597-.05 3.93 3.93 0 0 0 .048-5.546l-9.154-9.073zm-76.02 56.26a3.932 3.932 0 0 0-.584 5.528 4.018 4.018 0 0 0 5.57.651c.38-.296 37.877-29.337 74.872 0a4.024 4.024 0 0 0 3.948.597 3.965 3.965 0 0 0 2.496-3.09 3.94 3.94 0 0 0-1.452-3.686c-41.926-33.235-84.422-.33-84.85 0z",
    fill: "url(#u9gwp9vqqa)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.f1d961141254402b2ca3b063224cf771.svg";
export { ForwardRef as ReactComponent };